import { useState } from 'react';
import { useTranslation } from 'next-i18next';
import dynamic from 'next/dynamic';
import Button from '../common/Button';
import { useSelector } from '../../core/redux/store';
import Stars from '../common/Icons/Stars';

const LoginModal = dynamic(() => import('./LoginModal'));
const SignUpModal = dynamic(() => import('./SignUpModal'));

type Props = {
  hasMemberDiscount?: boolean;
  memberDiscountPercentage?: number;
};

const AuthenticationSection = ({ hasMemberDiscount, memberDiscountPercentage }: Props) => {
  const { userAttributes } = useSelector((x) => x.account);
  const { t } = useTranslation(['common', 'component', 'error']);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState<boolean>(false);
  const [isSignUpModalOpen, setIsSignUpModalOpen] = useState<boolean>(false);

  const events = {
    onClickLogin: () => {
      setIsLoginModalOpen(true);
    },
    onClickRegister: () => {
      setIsSignUpModalOpen(true);
    },
  };

  return !userAttributes?.accountId ? (
    <>
      <div className="relative flex rounded-lg border border-orange-700 bg-orange-50 text-orange-700">
        <div className="-ml-px hidden w-10 rounded-l-lg bg-orange-700 after:relative after:left-6 after:inline-block after:h-full after:w-4 after:rounded-concave after:bg-orange-50 md:block" />
        <div className="flex w-full flex-col justify-between gap-4 px-3 py-4 md:flex-row md:items-center lg:py-5 lg:pl-4 lg:pr-6">
          <div className="flex flex-row items-center gap-2">
            <div className="size-12">
              <Stars size={48} />
            </div>
            <p className="text-lg font-bold md:text-2xl">
              {hasMemberDiscount && !!memberDiscountPercentage
                ? t('component:authentication_section.member_discount_title', {
                    percentage: memberDiscountPercentage,
                  })
                : t('component:authentication_section.have_account')}
            </p>
          </div>

          <div className="flex shrink-0 justify-center gap-4 md:ml-8">
            <Button
              onClick={() => events.onClickLogin()}
              rounded
              size="small"
              color="red"
              textColor="white"
              className="grow md:px-4 md:py-2.5 lg:px-12 lg:py-3"
            >
              {t('button.login')}
            </Button>
            <Button
              onClick={() => events.onClickRegister()}
              rounded
              border
              size="small"
              color="white"
              textColor="red"
              className="grow md:px-4 md:py-2.5 lg:px-12 lg:py-3"
            >
              {t('button.register_short')}
            </Button>
          </div>
        </div>
      </div>
      {isLoginModalOpen && <LoginModal setIsOpen={setIsLoginModalOpen} />}
      {isSignUpModalOpen && <SignUpModal setIsOpen={setIsSignUpModalOpen} />}
    </>
  ) : null;
};

export default AuthenticationSection;
